module.exports = __webpack_public_path__ + "static/media/logo-white1.1e5846ad.png";